import { HandBookIPort, MirIPort, SBPIPort, WalletIPort } from '@/shared/lib/@deprecated/iport-icons/index'

export const spbDeliveryInfo = [
	{
		title: `Доставка по Санкт-Петербургу и Ленинградской области`,
		timeWork: `Ежедневно с 12:00 до 20:00`,
		noteList: [
			'Заказ свыше 200 000 ₽ доставляем \n' + 'по 100% предоплате.',
			'Доставка день в день возможна, только \n' + 'для товаров весом до 15 кг.',
			`Условия доставки для юридических лиц уточняйте у менеджера корпоративного отдела <a style="white-space: nowrap" href="tel:88123183836">+7 (812) 318-38-36</a>`,
			`При весе заказа более 15 кг дополнительно оплачивается подъем до квартиры и, если проезд автомобиля к подъезду ограничен/невозможен, пронос до подъезда. Стоимость уточняйте при согласовании условий доставки у операторов контакт-центра.`
		],
		dayDeliveryInfoList: [
			{
				name: `День в день`,
				items: [
					{
						description: `Стоимость доставки  — <b>750 ₽ </b>`
					},
					{
						description: `Только при оформлении заказа от 15 000 ₽ до 16:30`
					},
					{
						description: `Оплата только онлайн на сайте`
					}
				]
			},
			{
				name: `На следующий день`,
				items: [
					{
						description: `При заказе на сумму более 15 000 ₽ — <b>бесплатно</b>`
					},
					{
						description: `При заказе на сумму менее 15 000 ₽ —  <b>600 ₽</b>`
					},
					{ description: `Доставка за пределы КАД` }
				]
			},
			{
				name: `Доставка по России`,
				note: `Для крупногабаритных товаров, а также товаров из категории TV, пылесосов, электросамокатов и климатической техники действуют индивидуальные условия доставки. Сроки и конечная стоимость рассчитываются индивидуально. Доставка товаров из раздела Уценка в другие регионы не производится.`,
				items: [
					{
						description: `При заказе на сумму более 15 000 ₽ — <b>бесплатно</b>`
					},
					{
						description: `При заказе на сумму менее 15 000 ₽ —  <b>600 ₽</b>`
					},
					{
						description: `Оплата только онлайн на сайте`
					}
				]
			}
		]
	}
]
export const spbDeliveryInfoYur = [
	{
		dayDeliveryInfoList: [
			{
				name: `Доставка по Ленинградской области за пределами КАД`,
				timeWork: `Ежедневно с 11:00 до 21:00`,
				items: [
					{
						description: `От 0 до 30 км от КАД  — <b>600 ₽</b>`
					},
					{
						description: `От 30 до 60 км от КАД — <b>1 200 ₽</b>`
					},
					{
						description: `Более 60 км от КАД — <b>рассчитывается индивидуально</b>`
					},
					{
						description: `Оплата по счёту`
					},
					{
						description: `Доставка осуществляется на следующий день после зачисления оплаты на расчётный счёт поставщика, если товар есть на складе отгрузки. В остальных случаях сроки доставки согласовываются с менеджером`
					}
				]
			}
		],
		countryDeliveryInfoList: [
			{
				name: `Доставка по России`,
				timeWork: `Ежедневно с 11:00 до 21:00`,
				items: [
					{
						description: `Рассчитывается индивидуально. Стоимость зависит от удалённости региона`
					},
					{
						description: `Работаем с разными транспортными компаниями: Cargo-Express, Деловые Линии, СДЭК`
					},
					{
						description: `Можем отправить заказ вашей логистической компанией`
					}
				]
			}
		],
		countryDeliveryInfoList2: [
			{
				name: `Доставка по Санкт-Петербургу в пределах КАД`,
				timeWork: `Ежедневно с 11:00 до 21:00`,
				note: `*За исключением крупногабаритных товаров. Подъём и пронос оплачиваются отдельно —  200 ₽ за этаж`,
				items: [
					{
						description: `Стоимость заказа на сумму менее 150 000 ₽  —  <b>500 ₽</b>`
					},
					{
						description: `Стоимость заказа на сумму более 150 000 ₽ — <b>бесплатно*</b>`
					},
					{
						description: `Оплата по счёту`
					},

					{
						description: `Доставка осуществляется на следующий день после зачисления оплаты на расчётный счёт поставщика, если товар есть на складе отгрузки. В остальных случаях сроки доставки согласовываются с менеджером.`
					}
				]
			}
		]
	}
]

export const defaultDeliveryInfo = [
	{
		title: `Доставка по городу`,
		timeWork: `Доставка осуществляется с 12.00 до 20.00`,
		noteList: [
			'Доставка осуществляется в течение 1-3 дней после подтверждения заказа оператором',
			'Доставка возможна только для товаров весом до 15 кг',
			`Условия доставки для юридических лиц уточняйте у менеджера корпоративного отдела <a style="white-space: nowrap" href="tel:88123183836">+7 (812) 318-38-36</a>`
		],
		dayDeliveryInfoList: [
			{
				items: [
					{
						description: `При заказе на сумму более 15 000 ₽ - <b>бесплатно</b>`
					},
					{
						description: `При заказе на сумму менее 15 000 ₽ - <b>600 ₽</b>`
					},
					{
						description: `<b>Оплата</b> только онлайн`
					}
				]
			}
		]
	},
	{
		title: `Доставка по области`,
		noteList: [
			`Доставка по области рассчитывается индивидуально`,
			`Позвоните нам по бесплатному номеру <a style="white-space: nowrap" href="tel:88007700097">+7 800 77-000-97</a> или напишите в онлайн&#8209;чат.`
		]
	}
]
export const deliveryPickUpInfo = [
	{
		title: `Забрать в магазине`,
		timeWork: `Ежедневно с 10:00 до 22:00.`,
		description: `Вы можете забронировать нужный товар в&nbsp;любом<br/> <a href="/shops/">магазине iPort</a> и&nbsp;забрать его в&nbsp;удобное для вас время.`,
		dayDeliveryInfoList: [
			{
				name: `Забронировать в магазине`,
				items: [
					{
						description: `Оформите заказ`,
						note: 'через сайт или по телефону'
					},
					{
						description: `Дождитесь подтверждения`,
						note: 'свяжемся с вами, чтобы подтвердить заказ'
					},
					{
						description: 'Заберите заказ',
						note: 'зарезервируем товар на 3 дня'
					}
				],
				numberList: true
			}
		]
	}
]
export const deliveryPayGrid = [
	{
		icons: [MirIPort],
		title: `Картой или наличными`,
		description: `Оплата онлайн или при получении.`
	},
	{
		icons: [WalletIPort],
		title: `Безналичный расчет`,
		description: `Перевод по реквизитам от физического лица.`
	},
	{
		icons: [HandBookIPort],
		title: `Рассрочка или кредит`,
		description: `на технику Apple.`
	},
	{
		icons: [SBPIPort],
		title: `Система быстрых платежей (СБП)`,
		description: `Оплата онлайн по QR коду`
	}
]

export const deliveryPayGridYur = [
	{
		icons: [WalletIPort],
		title: `Безналичный расчет`,
		description: `Оплата по счёту от юридического лица`
	}
]

export const faqItems = [
	{
		question: `В какие города и по каким условиям возможна доставка iPort?`,
		answer: `Доставляем во все города РФ. При заказе на сумму от 15 000 ₽ доставка бесплатная. При заказе на сумму до 15 000 ₽ стоимость доставки 600 ₽. При доставке по России оплата только онлайн на сайте. Для крупногабаритных товаров действуют индивидуальные условия доставки. Сроки и конечная стоимость рассчитываются индивидуально. Отправление товаров из раздела Уценка в другие регионы не производится.<br />Доставка по Санкт-Петербургу и Ленинградской области возможна день в день при оформлении заказа от 15 000 ₽ до 16:30 (только для товаров весом до 15 кг), стоимость доставки - 750 ₽.`
	},
	{
		question: `Как проверить iPhone при доставке?`,
		answer: `Проверьте коробку. Важно, чтобы коробка была именно «родная», а не от другого устройства, не имела дефектов, повреждений.<br /> Вскрыв коробку, в первую очередь проверьте комплектацию устройства и наличие всех аксессуаров. Если не хватает кабеля и на iPhone присутствуют следы использования, откажитесь от покупки. Включив устройство, проверьте соответствие IMEI в коробке и на iPhone. Определяется этот параметр сразу на стартовом экране. Если данные совпадают, вставьте сим-карту, активируйте устройство.
`
	},
	{
		question: `Что делать, если заказ доставлен с браком?`,
		answer: `Покупатель, которому продан товар ненадлежащего качества, если это не было оговорено продавцом, вправе по своему выбору потребовать:
    <br />
    <ul><li>безвозмездного устранения недостатков товара или возмещения расходов на их исправление покупателем или третьим лицом;</li>
    <li>соразмерного уменьшения покупной цены;</li>
    <li>замены на товар аналогичной марки (модели, артикула) или на такой же товар другой марки (модели, артикула) с соответствующим перерасчетом покупной цены.</li>
    </ul>
    <br />При этом в отношении технически сложных и дорогостоящих товаров эти требования покупателя подлежат удовлетворению в случае обнаружения существенных недостатков. Обмен или возврат товара осуществляется в любом розничном магазине, независимо от места покупки, в розничном магазине или интернет-магазине. Если вы приняли решение об обмене или возврате в день покупки, то вам следует обратиться в тот же магазин, где был приобретен товар. Товар, приобретенный в интернет-магазине, нельзя обменять или вернуть день в день. Для вашего удобства, если товар был куплен в интернет-магазине, мы рекомендуем вам позвонить по телефону интернет-магазина.`
	},
	{
		question: `Как отследить свой заказ?`,
		answer: `В Санкт-Петербурге заказ можно отследить через менеджера контакт-центра. Доставки в Регионы РФ осуществляются транспортными компаниями. Отследить заказ можно только через трек-номер, который приходит по смс в день отправки.`
	},
	{
		question: `Как перенести место или время доставки?`,
		answer: `Вы можете связаться с менеджером контакт-центра и сообщить, когда удобно будет принять товар. `
	},
	{
		question: `Что делать если товар приехал повреждённым?`,
		answer: `Если при получении груза вы видите, что упаковка повреждена, не подписывайте документы о получении, а потребуйте составить акт о повреждении. Далее, совместно с сотрудником транспортной компании на выдаче вскройте поврежденную упаковку и осмотрите груз, при этом фиксируя данный процесс на фото или видео. Если видимых повреждений нет, но характер груза не исключает внутренние дефекты, обязательно зафиксируйте данное обстоятельства в акте о повреждении. Ссылку на акт о повреждении груза необходимо обязательно указать также в документах на выдачу груза (акте оказанных услуг).`
	}
]
